/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatListDto } from '../models/ChatListDto';
import type { ChatListOrder } from '../models/ChatListOrder';
import type { ChatMessageCountResponse } from '../models/ChatMessageCountResponse';
import type { ChatMessageList } from '../models/ChatMessageList';
import type { ChatMessageSearchResult } from '../models/ChatMessageSearchResult';
import type { ChatMessageStatus } from '../models/ChatMessageStatus';
import type { DetailedChatMessage } from '../models/DetailedChatMessage';
import type { LoginResponseDto } from '../models/LoginResponseDto';
import type { MessagesKeysetPageResponsePpvMessagePreviewResponseDto } from '../models/MessagesKeysetPageResponsePpvMessagePreviewResponseDto';
import type { OnlyFansChatDto } from '../models/OnlyFansChatDto';
import type { OnlyFansMessage } from '../models/OnlyFansMessage';
import type { SendMessageRequest } from '../models/SendMessageRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfChatMessagesService {
    /**
     * Unpin chat message
     * Unpin a chat message by a specific ID.
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static unpinChatMessage({
        creatorId,
        messageId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the message whose to be unpinned
         */
        messageId: number,
        userId: number,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}/unpin',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
                'userId': userId,
            },
        });
    }
    /**
     * Pin chat message
     * Pin a chat message by a specific ID.
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static pinChatMessage({
        creatorId,
        messageId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the message whose to be pinned
         */
        messageId: number,
        userId: number,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}/pin',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static likeChatMessage({
        creatorId,
        userId,
        messageId,
    }: {
        creatorId: number,
        userId: number,
        messageId: number,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}/like',
            path: {
                'creatorId': creatorId,
                'userId': userId,
                'messageId': messageId,
            },
        });
    }
    /**
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static unlikeChatMessage({
        creatorId,
        userId,
        messageId,
    }: {
        creatorId: number,
        userId: number,
        messageId: number,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}/like',
            path: {
                'creatorId': creatorId,
                'userId': userId,
                'messageId': messageId,
            },
        });
    }
    /**
     * Send a message
     * Sends a message to a specified user.
     * @returns OnlyFansMessage Returned next page of ppv messages with statues.
     * @throws ApiError
     */
    public static sendMessage({
        creatorId,
        userId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the user.
         */
        userId: number,
        /**
         * JSON payload containing the message content and metadata.
         */
        requestBody: SendMessageRequest,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/message',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Mark chat as unread
     * Mark chat as unread for the given creator and the user
     * @returns void
     * @throws ApiError
     */
    public static markChatAsUnread({
        creatorId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the user
         */
        userId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/chat/mark-as-unread',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Mark chat as read
     * Mark chat as read for the given creator and the user
     * @returns void
     * @throws ApiError
     */
    public static markChatAsRead({
        creatorId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the user
         */
        userId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/chat/mark-as-read',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Mark all as read
     * Mark all unread chat messages in a chat from a creator as read
     * @returns void
     * @throws ApiError
     */
    public static markAllAsRead({
        creatorId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/markAllAsRead',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static getRecentMediaMessages({
        creatorId,
        userId,
        since,
    }: {
        creatorId: number,
        userId: number,
        since: string,
    }): CancelablePromise<Array<OnlyFansMessage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/recent-media-messages',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'since': since,
            },
        });
    }
    /**
     * Retrieve paginated chat messages
     * Retrieves a paginated list of chat messages exchanged between the creator and the chat user.
     * @returns ChatMessageList OK
     * @throws ApiError
     */
    public static getChatMessages({
        creatorId,
        userId,
        limit,
        anchorMessageId,
        includeAnchor = true,
        descending = true,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the user.
         */
        userId: number,
        /**
         * The maximum number of messages to retrieve.
         */
        limit: number,
        /**
         * The message to start on (excluded in result).
         */
        anchorMessageId?: number,
        /**
         * Flag indicating if the anchor message should be included as well (Default: true)
         */
        includeAnchor?: boolean,
        /**
         * Direction of the retrieval (true = anchor is the oldest message, false = the newest). (Default: true)
         */
        descending?: boolean,
    }): CancelablePromise<ChatMessageList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'anchorMessageId': anchorMessageId,
                'limit': limit,
                'includeAnchor': includeAnchor,
                'descending': descending,
            },
        });
    }
    /**
     * @returns DetailedChatMessage OK
     * @throws ApiError
     */
    public static getDetailedChatMessage({
        creatorId,
        userId,
        messageId,
    }: {
        creatorId: number,
        userId: number,
        messageId: number,
    }): CancelablePromise<DetailedChatMessage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}/detailed',
            path: {
                'creatorId': creatorId,
                'userId': userId,
                'messageId': messageId,
            },
        });
    }
    /**
     * Search messages in chat
     * Search messages in a chat for a specific user based on text.
     * @returns ChatMessageSearchResult OK
     * @throws ApiError
     */
    public static searchMessage({
        creatorId,
        userId,
        text,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the user whose chat is to be searched
         */
        userId: number,
        /**
         * Text to search in messages
         */
        text: string,
    }): CancelablePromise<ChatMessageSearchResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/query',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'text': text,
            },
        });
    }
    /**
     * @returns ChatMessageList OK
     * @throws ApiError
     */
    public static getPinnedMessages({
        creatorId,
        userId,
        anchorMessageId,
    }: {
        creatorId: number,
        userId: number,
        anchorMessageId?: number,
    }): CancelablePromise<ChatMessageList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/pinned',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'anchorMessageId': anchorMessageId,
            },
        });
    }
    /**
     * @returns ChatMessageSearchResult OK
     * @throws ApiError
     */
    public static getPinnedMessagesQuery({
        creatorId,
        userId,
        query,
    }: {
        creatorId: number,
        userId: number,
        query?: string,
    }): CancelablePromise<ChatMessageSearchResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/pinned/query',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'query': query,
            },
        });
    }
    /**
     * Retrieve one single chat of a given creator and user.
     * @returns OnlyFansChatDto Chat data
     * @throws ApiError
     */
    public static getChat({
        creatorId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The userId of the specific user
         */
        userId: number,
    }): CancelablePromise<OnlyFansChatDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/chat',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Retrieves a paginated list of PPV chat messages with statuses sent by creator.
     * Retrieve paginated PPV messages from creator to fans with their statuses and media preview.
     *
     * Ordered from most recent to least recent.
     *
     * This is a keyset pagination, only forward. Make sure to store already retrieved results to navigate backward locally.
     *
     * Next page could be requested by specifying pair of parameters (**fromCreatedAt**=last.sentAt, **fromCreatedAt**=last.onlyfansMessageId) from last message in response.
     *
     * Note: When one of params (**fromCreatedAt**, fromOfMessageId) is specified, other one must be too.
     *
     * Note: Currently messages statuses recalculated internally every minute (this may change in the future), so don't expect realtime statues freshness.
     *
     * @returns MessagesKeysetPageResponsePpvMessagePreviewResponseDto Returned next page of ppv messages with statues.
     * @throws ApiError
     */
    public static getNextPpvMessagesWithStatus({
        creatorId,
        fromCreatedAt,
        fromOfMessageId,
        limit = 50,
        status,
    }: {
        /**
         * Internal ID of the creator.
         */
        creatorId: number,
        /**
         * Get messages with sentAt <= fromCreatedAt.
         */
        fromCreatedAt?: string,
        /**
         * Get messages with onlyfansMessageId < fromOfMessageId (to break ties when sentAt is the same).
         */
        fromOfMessageId?: number,
        /**
         * Limit number of messages in response.
         */
        limit?: number,
        /**
         * Message status filter. If not specified - all statuses are retrieved.
         */
        status?: ChatMessageStatus,
    }): CancelablePromise<MessagesKeysetPageResponsePpvMessagePreviewResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/ppv-messages',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'fromCreatedAt': fromCreatedAt,
                'fromOfMessageId': fromOfMessageId,
                'limit': limit,
                'status': status,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Returns is user logged in
     * @returns LoginResponseDto OK
     * @throws ApiError
     */
    public static getLoggedInState({
        creatorId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
    }): CancelablePromise<LoginResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/logged-in',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Retrieves a paginated list of chats for a given creator, filtered and sorted according to specified parameters.
     * @returns ChatListDto Chat list (data)
     * @throws ApiError
     */
    public static getChats({
        creatorId,
        pageSize,
        page,
        order,
        listFilter = '',
        filter = '',
        query = '',
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * Number of items per page (always 10 for now)
         */
        pageSize: number,
        /**
         * Page number
         */
        page: number,
        /**
         * Sorting order: recent or old
         */
        order?: ChatListOrder,
        /**
         * ID of a list to filter on
         */
        listFilter?: string,
        /**
         * OF Pre defined filter parameter (e.g. who_tipped)
         */
        filter?: string,
        /**
         * Text query filter parameter
         */
        query?: string,
    }): CancelablePromise<ChatListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/list',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'pageSize': pageSize,
                'page': page,
                'order': order,
                'listFilter': listFilter,
                'filter': filter,
                'query': query,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Get Unread Chats Count
     * Get Unread Chats Count for the given creator
     * @returns ChatMessageCountResponse OK
     * @throws ApiError
     */
    public static getUnreadChatsCount({
        creatorId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
    }): CancelablePromise<ChatMessageCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/count',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                400: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Delete chat message
     * Delete a chat message by a specific ID.
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static deleteChatMessage({
        creatorId,
        messageId,
        userId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The OnlyFans ID of the message whose to be deleted
         */
        messageId: number,
        userId: number,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-chat/{creatorId}/{userId}/messages/{messageId}',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
                'userId': userId,
            },
        });
    }
}
